import React from 'react'
import {Jumbotron} from 'react-bootstrap';

export const Jumbotroni = () => {
    return (
        <div>
  <Jumbotron>
    <ul>
    <li><h5>We supply spares for Detroit” Series 60</h5></li>
    <li><h5>We supply spares for Cummins” 4BT, 6BT, 6CT, M11, N14, ISX15</h5></li>
    <li><h5>We supply spares for Caterpillar- C9, 3306, C7, C15</h5></li>
    </ul>
  </Jumbotron>    
        </div>
    )
}

export default  Jumbotroni;